<ng-container *transloco="let t; prefix: 'orders'">
  <div class="summary-layout">
    <section class="summary-main">
      <div class="summary-section">
        <div class="summary-section-header">
          <div class="summary-section-icon" aria-hidden="true">
            <i class="fa-regular fa-user"></i>
          </div>
          <span class="title-medium-emphasized">{{ 'orders.ui.cliente' | transloco }}</span>
        </div>

        <div class="summary-customer">
          <span class="title-medium emphasized">{{ proposal()?.ragioneSociale ?? '-' }}</span>
          @if (customerCodes()) {
            <span class="body-medium">{{ customerCodes() }}</span>
          }
        </div>
        <ord-proposal-anomalies />
      </div>

      <mat-divider></mat-divider>

      <div class="summary-section summary-section--products">
        <div class="summary-section-header">
          <div class="summary-section-icon" aria-hidden="true">
            <i class="fa-regular fa-box"></i>
          </div>
          <span class="title-medium-emphasized">{{ 'orders.ui.prodotti' | transloco }}</span>
        </div>

        @if (rows().length === 0) {
          <span class="body-medium">{{ 'orders.ui.ilCarrelloEVuoto' | transloco }}</span>
        } @else {
          <div class="summary-products-list">
          @for (row of rows(); track row.id) {
            <div class="summary-row">
              <div class="summary-row-header">
                <div class="summary-row-product">
                  <span class="body-medium emphasized summary-row-name">{{ row.nomeProdotto }}</span>
                  <span class="body-small">@if (row.sku) { {{ row.sku }} - }{{ row.nomeImballo ?? '-' }} - {{ row.unitaFatturabile }} {{ row.unitaMisura }}</span>
                </div>

                <div class="quantity-stepper">
                  <button matButton="tonal" type="button" [attr.aria-label]="'orders.ui.rimuoviRiga' | transloco" class="stepper-button" (click)="remove(row)">
                    <i class="fa-regular fa-trash-can"></i>
                  </button>

                  @if (row.quantita > 1) {
                    <button matButton="tonal" type="button" [attr.aria-label]="'orders.ui.diminuisciQuantita' | transloco" class="stepper-button" (click)="decrement(row)">
                      <i class="fa-regular fa-minus"></i>
                    </button>
                  }

                  <span class="body-medium emphasized quantity-value">{{ row.quantita }}</span>

                  <button matButton="tonal" type="button" [attr.aria-label]="'orders.ui.aumentaQuantita' | transloco" class="stepper-button" (click)="increment(row)">
                    <i class="fa-regular fa-plus"></i>
                  </button>
                </div>
              </div>

              <div class="summary-row-detail">
                <span class="body-medium summary-row-label">{{ 'orders.ui.prezzoUnitario' | transloco }}</span>
                <span class="body-medium summary-row-value">
                  {{ row.prezzo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 4, maximumFractionDigits: 4 } }}/{{ row.unitaMisura }}
                  @if (!row.prezzoBloccato) {
                    <button mat-icon-button type="button" [attr.aria-label]="'orders.ui.modificaPrezzo' | transloco" class="edit-price-button" (click)="editPrice(row)">
                      <i class="fa-regular fa-pen"></i>
                    </button>
                  }
                </span>
              </div>

              @if (row.percScontoDerivato) {
                <div class="summary-row-detail">
                  <span class="body-medium summary-row-label">{{ 'orders.ui.sconto' | transloco }}</span>
                  <span class="body-medium summary-row-value">{{ row.percScontoDerivato | translocoDecimal: { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}%</span>
                </div>
              }

              <div class="summary-row-detail">
                <span class="body-medium summary-row-label">{{ 'orders.ui.subtotale' | transloco }}</span>
                <span class="body-medium summary-row-value">
                  {{ row.imponibile | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 4, maximumFractionDigits: 4 } }}
                </span>
              </div>

              @if (row.provvigioneDisponibile) {
                <div class="summary-row-detail">
                  <span class="body-medium summary-row-label">{{ 'orders.ui.provvigioneAgente' | transloco }}</span>
                  <span class="body-medium summary-row-value">{{ row.percProvvigione }}%</span>
                </div>

                <div class="summary-row-detail">
                  <span class="body-medium summary-row-label">{{ 'orders.ui.importo' | transloco }}</span>
                  <span class="body-medium summary-row-value">
                    {{ row.provvigione | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 4, maximumFractionDigits: 4 } }}
                  </span>
                </div>
              }
            </div>

            @if (!$last) {
              <mat-divider></mat-divider>
            }
          }
          </div>
        }
      </div>
    </section>

    <aside class="summary-totals">
      <div class="summary-totals-row">
        <span class="body-medium emphasized">{{ 'orders.ui.subtotale' | transloco }}</span>
        <span class="body-medium emphasized">
          {{ cart()?.totaleImponibile ?? 0 | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
        </span>
      </div>

      <div class="summary-totals-row">
        <span class="body-small">CONOU</span>
        <span class="body-small">
          {{ cart()?.totaleConou ?? 0 | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
        </span>
      </div>

      <div class="summary-totals-row">
        <span class="title-large">{{ 'orders.ui.totale' | transloco }}</span>
        <span class="title-large">
          @if (cart()?.totale != null) {
            {{ cart()?.totale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
          } @else {
            -
          }
        </span>
      </div>

      @if (cart()?.totaleProvvigione != null) {
        <div class="summary-totals-row">
          <span class="body-small">{{ 'orders.ui.totProvvigioniAgente' | transloco }}</span>
          <span class="body-small">
            {{ cart()!.totaleProvvigione | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
          </span>
        </div>
      }

      <div class="summary-totals-actions">
        @if (busy()) {
          <ui-loading-spinner />
        }

        <button
          *uiCan="capabilityNames.preventivoGenera"
          matButton="outlined"
          type="button"
          [disabled]="!cart() || quoteInAuthorization() || busy()"
          (click)="generateQuote()"
        >
          {{ 'orders.ui.generaPreventivo' | transloco }}
        </button>

        <button
          matButton="filled"
          type="button"
          [disabled]="!cart() || quoteInAuthorization() || busy()"
          (click)="sendProposal()"
        >
          {{ 'orders.ui.inviaProposta' | transloco }}
        </button>
      </div>
    </aside>
  </div>
</ng-container>
